/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * March 2022
 */

import React from 'react';
import {withRouter} from "react-router";
import Row from "react-bootstrap/cjs/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import BootstrapTable from "react-bootstrap-table-next";
import API from "../../lib/api/NbioApi";
import Card from "react-bootstrap/Card";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import {DateRangePicker} from "react-date-range";
import es from "date-fns/locale/es";
import {defaultInputRanges, defaultStaticRanges} from "react-date-range/dist/defaultRanges";
import NPIf from "np-if";
import NPElse from "np-if/src/NPElse";
import Spinner from "react-bootstrap/cjs/Spinner";


//const
const dayjs = require('dayjs')
const utc   = require('dayjs/plugin/utc');
dayjs.extend(utc);

const staticRangesLabels = {
    "Today": "Hoy",
    "Yesterday": "Ayer",
    "This Week": "Esta semana",
    "Last Week": "La última semana",
    "This Month": "Este mes",
    "Last Month": "El último mes"
};
const inputRangesLabels = {
    "days up to today": "Días hasta hoy",
    "days starting today": "Días a partir de hoy"
};

function translateRange(dictionary) {
    return (item) =>
        dictionary[item.label] ? {...item, label: dictionary[item.label]} : item;
}

const esStaticRanges = defaultStaticRanges.map(translateRange(staticRangesLabels));
const esInputRanges  = defaultInputRanges.map(translateRange(inputRangesLabels));



class AdsAnalytics extends React.Component {
    constructor(p) {
        super(p);
        this.state = {
            adClicksData: [],
            adConversionsData: [],
            selectedRanges: {
                startDate: dayjs().startOf('week').toDate(),
                endDate: dayjs().endOf('week').toDate(),
                key: 'selection',
            },
            dateMode:'week',
            isLoading: true
        }

        this.loadAdClicks      = this.loadAdClicks.bind(this);
        this.loadAdConversions = this.loadAdConversions.bind(this);
        this.loadProductStats   = this.loadProductStats.bind(this);
    }

    componentDidMount(){
        this.loadProductStats();
    }

    loadProductStats = () => {
        this.loadAdConversions();
        this.loadAdClicks();
    }

    loadAdConversions = () => {
        const startDate = this.getStartDate();
        const endDate   = this.getEndDate();

        API.analytics.getAdConversions(startDate,endDate).then((res) =>{
            this.setState({adConversionsData:res.data.data,isLoading:false})
        }).catch((ex) =>{
            this.setState({isLoading:false})
        })
    }


    loadAdClicks = () => {
        const startDate = this.getStartDate();
        const endDate   = this.getEndDate();

        API.analytics.getAdClicks(startDate,endDate).then((res) =>{
            this.setState({adClicksData:res.data.data})
        }).catch((ex) =>{

        })
    }

    handleDateSelect(ranges) {
        this.setState({
            selectedRanges: ranges.selection,
            dateMode:'range',
            isLoading: true
        }, () =>{
            this.loadAdConversions();
            this.loadAdClicks();
        });
    }

    onAllDatesClicked = () => {
        this.setState({
            dateMode:'all',
            isLoading: true
        }, () =>{
            this.loadAdConversions();
            this.loadAdClicks();
        });
    }

    getStartDate = () => {
        if(this.state.dateMode === 'range'){
            return dayjs(this.state.selectedRanges.startDate).format('MM-DD-YYYY');
        }else if(this.state.dateMode === 'all'){
            const d = new Date(2021, 10, 1);
            return dayjs(d).format('MM-DD-YYYY');
        }else{
            return '';
        }
    }

    getEndDate = () => {
        if(this.state.dateMode === 'range'){
            return dayjs(this.state.selectedRanges.endDate).format('MM-DD-YYYY');
        }else if(this.state.dateMode === 'all'){
            return dayjs().endOf('day').format('MM-DD-YYYY');
        }else{
            return '';
        }
    }

    render() {
        const columns = [
            {
                dataField: '_id',
                text: 'ID',
                formatter:(value,row)=>{
                    return(
                        <div>{value.adId}</div>
                    )
                },
            },
            {
                dataField: '_id',
                text: 'Anuncio',
                formatter:(value,row)=>{
                    return(
                        <div>{value.adName}</div>
                    )
                },
            },
            {
                dataField: 'count',
                text: 'Cantidad',
                formatter:(value,row)=>{
                    return value
                },
            }
        ]
        const columns2 = [
            {
                dataField: '_id',
                text: 'ID',
                formatter:(value,row)=>{
                    return(
                        <div>{value._id}</div>
                    )
                },
            },
            {
                dataField: '_id',
                text: 'Anuncio',
                formatter:(value,row)=>{
                    return(
                        <div>{value.name}</div>
                    )
                },
            },
            {
                dataField: 'count',
                text: 'Vistas',
                formatter:(value,row)=>{
                    return(
                        <div>{value}</div>
                        // <a href={`/products/${row._id}`}>{value}</a>
                    )

                },
            }
        ]
        return (
            <Container fluid className={'h-100'} style={{overflowY:"auto"}}>
                <Row>
                    <Col className='py-3 d-flex align-items-center justify-content-between'>
                        <h5 className={'text-capitalize'}>Estadísticas de anuncios</h5>
                        <Dropdown>
                            <Dropdown.Toggle variant="info" id="dates-filter-1">
                                <FontAwesomeIcon icon={'calendar'}/>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <div>
                                    <DateRangePicker
                                        locale={es} onChange={(v) => this.handleDateSelect(v)}
                                        ranges={[this.state.selectedRanges]}
                                        staticRanges={esStaticRanges}
                                        inputRanges={esInputRanges}
                                    >
                                    </DateRangePicker>
                                    <Button className={'ml-4'} onClick={() => this.onAllDatesClicked()}>Todas las fechas</Button>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={6} className='py-3'>
                        <Card >
                            <Card.Body>
                                <Card.Title className={'text-capitalize text-primary mb-4'}>
                                    Clicks en anuncios <span>{this.state.dateMode === 'week' ? 'por semana' : ''}</span>
                                </Card.Title>

                                <NPIf condition={this.state.isLoading}>
                                    <div className={'w-100 d-flex align-items-center justify-content-center'}
                                         style={{height:'100px'}}>
                                        <Spinner animation={"grow"} variant={'secondary'}></Spinner>
                                    </div>
                                    <NPElse>
                                        <BootstrapTable keyField='_id'
                                                        data={this.state.adClicksData} //
                                                        columns={columns}
                                                        noDataIndication={`No se encontraron datos`}
                                                        bordered={false}
                                                        striped={true}
                                        />
                                    </NPElse>
                                </NPIf>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={12} md={6} className='py-3'>
                        <Card >
                            <Card.Body>
                                <Card.Title className={'text-capitalize text-primary mb-4'}>
                                    Conversiones de anuncios <span>{this.state.dateMode === 'week' ? 'por semana' : ''}</span>
                                </Card.Title>
                                <NPIf condition={this.state.isLoading}>
                                    <div className={'w-100 d-flex align-items-center justify-content-center'}
                                         style={{height:'100px'}}>
                                        <Spinner animation={"grow"} variant={'secondary'}></Spinner>
                                    </div>
                                    <NPElse>
                                        <BootstrapTable keyField='_id'
                                                        data={this.state.adConversionsData} //
                                                        columns={columns2}
                                                        noDataIndication={`No se encontraron datos`}
                                                        bordered={false}
                                                        striped={true}
                                        />
                                    </NPElse>
                                </NPIf>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withRouter(AdsAnalytics);
